import React from 'react';
import Portrait from './Portrait';
import { TILT_RANGE } from '../data/constants';
import { useI18n } from '../i18n';

export default function Card({ card, drag, aesthetic, onPointerDown, frozen = false }) {
  const { tc, tr } = useI18n();
  if (!card) return null;
  const tilt = drag.x / 8;
  const rotation = Math.max(-TILT_RANGE, Math.min(TILT_RANGE, tilt));
  const dx = drag.x;
  const dy = Math.abs(drag.x) * 0.06;
  const cardClass = `card card--${aesthetic} card--${card.role}`;

  const text = tc(card.id);
  const title = text.title || card.title;
  const prompt = text.prompt || card.prompt;

  return (
    <div
      className={cardClass}
      style={{
        transform: `translate3d(${dx}px, ${-dy}px, 0) rotate(${rotation}deg)`,
        transition: frozen || drag.dragging
          ? 'none'
          : 'transform 320ms cubic-bezier(.22,1,.36,1)',
      }}
      onPointerDown={onPointerDown}
    >
      <div className="card__portrait">
        <Portrait role={card.role} name={card.name} />
        <div className="card__rolepill">{tr(card.role)}</div>
      </div>
      <div className="card__body">
        <div className="card__who">
          <div className="card__name">{card.name}</div>
          <div className="card__title">{title}</div>
        </div>
        <div className="card__prompt">{prompt}</div>
      </div>
    </div>
  );
}
